import * as React from 'react';

import EnterprisePageDataProvider from 'bundles/unified-common/providers/EnterprisePageDataProvider';
import EnterpriseUserSkillProfileProvider from 'bundles/unified-home-common/providers/enterprise/EnterpriseUserSkillProfileProvider';

const EnterpriseMyLearningPageProvider = ({ children }: React.PropsWithChildren<{}>) => {
  return (
    <EnterprisePageDataProvider>
      <EnterpriseUserSkillProfileProvider>{children}</EnterpriseUserSkillProfileProvider>
    </EnterprisePageDataProvider>
  );
};

export default EnterpriseMyLearningPageProvider;
